export class RotaModel {
  constructor(
    public rota: string = ""
  ) { }
}